import gsap from 'gsap'

class FlyoutBackground {
  constructor(el) {
    this.el = el
    return this
  }

  hide() {
    this.animateHide()
  }

  show(targetHeight) {
    this.el.height(targetHeight)
    this.animateShow()
  }

  change(sourceHeight, targetHeight) {
    // default source height is the current height
    sourceHeight = sourceHeight ? sourceHeight : this.el.height()
    this.animateHeight(sourceHeight, targetHeight)
  }

  animateHeight(sourceHeight, targetHeight) {
    // animate the flyout background
    gsap.fromTo(
      this.el,
      {
        height: sourceHeight,
      },
      {
        height: targetHeight,
        duration: 0.175,
        ease: 'sine.inOut',
      }
    )
  }

  animateShow() {
    // animate the form container
    gsap.fromTo(
      this.el,
      {
        yPercent: -5,
        opacity: 0,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.175,
        ease: 'sine.inOut',
      }
    )
  }

  animateHide() {
    // animate the form container
    gsap.fromTo(
      this.el,
      {
        yPercent: 0,
        opacity: 1,
      },
      {
        yPercent: -5,
        opacity: 0,
        duration: 0.175,
        ease: 'sine.inOut',
        onComplete: () => {
          // Remove the inline css style after anmation finished
          this.el.css('height', '')
        },
      }
    )
  }
}

export default FlyoutBackground
